// import external dependencies
import 'jquery';
import isMobile from 'ismobilejs';
import Sticky from 'sticky-js';
import flexslider from 'flexslider';
import mp from 'magnific-popup';
import btdp from 'bootstrap-datepicker';
//import pp from 'popper.js';
import bootstrap from 'bootstrap';
import 'bootstrap';



// Import everything from autoload
import './autoload/_bootstrap.js'

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
import woocommerceCheckout from './routes/woocommerce_checkout';

/** Populate Router instance with DOM routes */
window.isMobile = isMobile;
window.Sticky = Sticky;
window.flexslider = flexslider;
window.mp = mp;
window.btdp = btdp;
//window.pp = pp;
window.bootstrap = bootstrap;
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
  woocommerceCheckout,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js